// import req from "../../http/requests/dealership/index.js";
import http from "../../http/requests/admin/index.js";

export default {
  fetchUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .fetchUser(userID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA SINGLE USER");
          console.log(error);
          reject(error);
        });
    });
  },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      http
        .fetchUsers()
        .then(response => {
          commit("SET_USERS", response.data);
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA USERS");
          console.log(error);
          reject(error);
        });
    });
  },
  addUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .addUser(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA ADD USER");
          console.log(error);
          reject(error);
        });
    });
  },
  editUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .editUser(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA EDIT USER");
          console.log(error);
          reject(error);
        });
    });
  },
  deleteUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .deleteUser(userID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA DELETE USER");
          console.log(error);
          reject(error);
        });
    });
  },
  checkUsername(context, username) {
    return new Promise((resolve, reject) => {
      http
        .checkUsername(username)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA USERNAME");
          console.log(error);
          reject(error);
        });
    });
  },
  enableUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .enableUser(userID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA ENABLE USER");
          console.log(error);
          reject(error);
        });
    });
  },
  disableUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .disableUser(userID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA DISABLE USER");
          console.log(error);
          reject(error);
        });
    });
  },
};
